module.exports = __webpack_public_path__ + "img/time.8c1ba818.svg";